// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import Actions from "../../../actions/reports";
import DataList from "./DataList";
import update from "immutability-helper";

class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchParams: {
        paymentType: null,
        periodicity: 'month'
      },
    };
  }

  componentWillMount = () => {
    this.props.dispatch(Actions.fetchPlanOutpayments(this.state.fetchParams));
  };

  componentDidUpdate(prevProps) {
    if (this.props.location.key !== prevProps.location.key) {
      this.props.dispatch(Actions.fetchPlanOutpayments(this.state.fetchParams));
    }
  }

  onChangePeriodicity = value => {
    this.setState({
      fetchParams: update(this.state.fetchParams, {
        periodicity: { $set: value }
      })
    }, () => {
      this.props.dispatch(Actions.fetchPlanOutpayments(this.state.fetchParams));
    });
  };

  onChangePaymentType = value => {
    this.state.fetchParams.paymentType = value;
    this.setState({ fetchParams: this.state.fetchParams }, () => {
      this.props.dispatch(Actions.fetchPlanOutpayments(this.state.fetchParams));
    });
  };

  downloadReport = () => {
    Actions.downloadReport(this.state.fetchParams, 'planoutpayments.xlsx', 'planoutpayments.xlsx'); 
  }

  render() {
    const { isLoading, report, currentUser } = this.props;
    const { periodicity, fetchParams } = this.state;
    return (
      <DataList
        loading={isLoading}
        report={report}
        periodicity={fetchParams.periodicity}
        fetchParams={fetchParams}
        onChangePeriodicity={this.onChangePeriodicity}
        onChangePaymentType={this.onChangePaymentType}
        downloadReport={this.downloadReport}
        currentUser={currentUser}
      />
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.reports.isLoading,
  report: state.reports.report,
  currentUser: state.session.currentUser
});

export default connect(mapStateToProps)(Report);
